'use client'

import React from 'react'
import LandingLayout from '@components/Landing/LandingLayout'
import { BoldBlue, Content } from '@components/Landing/Common'
import Box from '@ui/Box'
import Title from '@components/Landing/Title'
import styled from 'styled-components'

const Subtitle = styled.h2`
  font-size: 56px;
  font-weight: 400;
  display: flex;
  align-items: center;
`

const OurGoalContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 46px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`
const OurGoalContentRight = styled.div``

const Contact = () => {
  return (
    <LandingLayout
      meta={
        <>
          <title>Our story - Enhanci</title>
        </>
      }
    >
      <Content maxWidth={1200}>
        <Title>Our story</Title>
        <Box fontSize={24}>
          <Box>
            Our story starts at the beginning of 2023. Once we discussed startups and
            various ideas, we noticed that although some services were excellent, their
            pricing tables did not quite catch the eye of users. Our curiosity led us to
            conduct research, revealing existing solutions in the market. <br />
            <br />
            The main problems we have found are: <br />
            <ol>
              <li>
                There are no analytics or A/B tests - it is impossible to see whether
                users like the pricing table or not.
              </li>
              <li>The design is usually old-fashioned and boring.</li>
              <li>Builders are too complicated.</li>
            </ol>
            <br />
            <br />
            So, we came up with the idea to create a builder that is{' '}
            <BoldBlue>easy to use</BoldBlue> and has an{' '}
            <BoldBlue>amazing pricing table design</BoldBlue>.
          </Box>
          <Subtitle>
            Our goal&nbsp;&nbsp;
            <svg
              width="90"
              height="90"
              viewBox="0 0 90 90"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="star-angle-svgrepo-com 1">
                <path
                  id="Vector"
                  d="M64.7269 23.7748C66.8516 24.3911 67.5896 27.5629 69.0653 33.9067L69.4474 35.5479C69.8666 37.3506 70.0763 38.2519 70.578 38.952C71.0794 39.6521 71.8159 40.0714 73.2893 40.9106L74.6303 41.6745C79.8146 44.6272 82.4066 46.1036 82.4977 48.5794C82.5885 51.0555 80.1176 52.8911 75.1766 56.5627L73.8983 57.5126C72.4943 58.5559 71.7919 59.0775 71.3441 59.8451C70.8968 60.6124 70.7539 61.539 70.4685 63.3915L70.209 65.0782C69.903 67.0646 69.4519 68.8331 68.9719 70.3324C68.232 72.6454 67.8619 73.8022 66.5164 74.5747C65.1713 75.3476 63.8704 74.9704 61.2694 74.2155M39.1493 25.2286L39.531 26.8698C39.9506 28.6725 40.1603 29.5739 40.6616 30.2739C41.1634 30.974 41.8999 31.3935 43.3733 32.2326L44.7143 32.9965C49.8986 35.9492 52.4906 37.4255 52.5814 39.9015C52.6721 42.3772 50.2016 44.2132 45.2606 47.8849L43.9823 48.8347C42.5779 49.878 41.8759 50.3996 41.4281 51.1672C40.9804 51.9345 40.8379 52.8607 40.5525 54.7136L40.2926 56.4004C39.2888 62.9201 38.7866 66.18 36.7183 67.0939C36.7183 67.0939 32.3851 65.9707 27.8553 61.896L26.6834 60.8419C25.3962 59.6839 24.7526 59.1052 23.9744 58.8795C23.1961 58.6537 22.3714 58.8067 20.7218 59.1127L19.2201 59.391C13.4153 60.468 10.5129 61.0061 9.14382 59.0951C7.77469 57.1841 8.84551 54.0892 10.9872 47.8995L11.5413 46.2982C12.1499 44.5391 12.4542 43.6597 12.4209 42.7526C12.3876 41.8459 12.0206 41.0137 11.2864 39.3502L10.618 37.8356C8.03453 31.9814 6.74277 29.0542 7.96497 26.9592C9.18713 24.8641 12.1138 24.9887 17.9672 25.2378L19.4816 25.3022C21.1449 25.373 21.9766 25.4083 22.7343 25.0735C23.492 24.7388 24.0899 24.0717 25.2857 22.7376L26.3743 21.5229C30.5824 16.828 32.6864 14.4805 34.8109 15.0968C36.9354 15.7131 37.6733 18.8849 39.1493 25.2286Z"
                  stroke="#3FE5EB"
                  strokeWidth="6"
                />
                <path
                  id="Vector_2"
                  opacity="0.5"
                  d="M44.7146 32.9954L73.2892 40.9096M36.7184 67.0929L61.2693 74.2145M41.4284 51.1659L71.3444 59.8441M34.811 15.0957L64.7272 23.7737"
                  stroke="#3FE5EB"
                  strokeWidth="6"
                />
              </g>
            </svg>
          </Subtitle>
          Help you turn your website visitors into happy customers. <br />
          <br />
          <OurGoalContent>
            <div>
              We would love to hear your thoughts on how we can make our builder even
              better or any cool features you would want. <br />
              <br />
              Got a wild idea? Share it with us – seriously,{' '}
              <BoldBlue $underlined>
                <a
                  href="https://enhanci.canny.io/general"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  we are all ears!
                </a>
              </BoldBlue>
            </div>
            <OurGoalContentRight>
              <svg
                width="174"
                height="226"
                viewBox="0 0 174 226"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="Group 68">
                  <g id="Group 63">
                    <g id="Group">
                      <g id="Group_2">
                        <g id="Group_3">
                          <g id="Group_4">
                            <path
                              id="Vector"
                              d="M150.682 20.4266L112.914 63.1248L102.781 49.9974L150.682 20.4266Z"
                              fill="#19676D"
                            />
                          </g>
                        </g>
                      </g>
                      <g id="Group_5">
                        <g id="Group_6">
                          <g id="Group_7">
                            <path
                              id="Vector_2"
                              d="M151.477 20.3411L123.15 87.5236L109.173 64.8827L151.477 20.3411Z"
                              fill="#37B7C1"
                            />
                          </g>
                        </g>
                      </g>
                      <g id="Group_8">
                        <g id="Group_9">
                          <g id="Group_10">
                            <path
                              id="Vector_3"
                              d="M150.681 20.425L79.844 37.6868L99.9699 55.0924L150.681 20.425Z"
                              fill="#37B7C1"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group 64">
                    <g id="Group_11">
                      <g id="Group_12">
                        <g id="Group_13">
                          <g id="Group_14">
                            <path
                              id="Vector_4"
                              d="M48.6168 179.29L22.7773 202.701L17.5023 194.037L48.6168 179.29Z"
                              fill="#19676D"
                            />
                          </g>
                        </g>
                      </g>
                      <g id="Group_15">
                        <g id="Group_16">
                          <g id="Group_17">
                            <path
                              id="Vector_5"
                              d="M49.1033 179.285L27.353 218.218L20.3827 203.511L49.1033 179.285Z"
                              fill="#37B7C1"
                            />
                          </g>
                        </g>
                      </g>
                      <g id="Group_18">
                        <g id="Group_19">
                          <g id="Group_20">
                            <path
                              id="Vector_6"
                              d="M48.6163 179.288L4.38848 185.006L15.45 196.944L48.6163 179.288Z"
                              fill="#37B7C1"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group 64_2">
                    <g id="Group_21">
                      <g id="Group_22">
                        <g id="Group_23">
                          <g id="Group_24">
                            <path
                              id="Vector_7"
                              d="M61.4916 87.3955L45.1933 123.807L56.4884 126.472L61.4916 87.3955Z"
                              fill="#19676D"
                            />
                          </g>
                        </g>
                      </g>
                      <g id="Group_25">
                        <g id="Group_26">
                          <g id="Group_27">
                            <path
                              id="Vector_8"
                              d="M61.3227 86.8677L26.6905 124.338L45.1601 126.702L61.3227 86.8677Z"
                              fill="#37B7C1"
                            />
                          </g>
                        </g>
                      </g>
                      <g id="Group_28">
                        <g id="Group_29">
                          <g id="Group_30">
                            <path
                              id="Vector_9"
                              d="M61.4952 87.3988L70.9656 137.536L54.0557 129.739L61.4952 87.3988Z"
                              fill="#37B7C1"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </OurGoalContentRight>
          </OurGoalContent>
        </Box>
      </Content>
    </LandingLayout>
  )
}

export default Contact
